import { isNotEmpty, isTheSame, isValidEmail, isValidPassword, } from '../../../hooks/formValidator/validators';
import { USER_PASSWORD_MIN_LENGTH } from '../../../app.config.vars/stored';
import { useMemo } from 'react';
export const buildInputValidationSchema = ({ password, formType, }) => {
    return {
        firstName: [isNotEmpty],
        lastName: [isNotEmpty],
        email: [isNotEmpty, isValidEmail],
        password: formType === 'create'
            ? [isNotEmpty, isValidPassword(USER_PASSWORD_MIN_LENGTH)]
            : [isValidPassword(USER_PASSWORD_MIN_LENGTH)],
        confirmPassword: [isTheSame(password)],
    };
};
const useEditorValidationSchema = ({ password, formType, }) => {
    const inputsValidationSchema = useMemo(() => buildInputValidationSchema({ password, formType }), [password, formType]);
    return { inputsValidationSchema };
};
export default useEditorValidationSchema;
